export const setRealDeviceHeight = () => {
  const vh = window.innerHeight;
  document.documentElement.style.setProperty("--device-view-height", `${vh}px`);
};
